import { initialModel } from '@atlassian/help-center-common-util/model';

export interface BrandingState {
	id: string;
	key: string;
	name: string;
	portalBaseUrl: string;
}

export type HandledActions = unknown;

const defaultState: BrandingState = { id: '', key: '', name: '', portalBaseUrl: '' };

export const getInitialState = (): BrandingState => {
	const initialModelState = initialModel();
	if (initialModelState?.branding) {
		return initialModelState.branding;
	}
	return defaultState;
};

export const brandingReducer = (
	state: BrandingState = getInitialState(),
	_: HandledActions,
): BrandingState => state;
